import { EPS_OPTIONS } from '../../constants/domain-specific';
import { BusinessDetails } from '../../slices/businessDetails';
import { CoverDetails } from '../../slices/coverDetails';
import { Quote } from '../../slices/quote';
import { Construction, Cover } from '../../types/cover';
import { RiskClassCode } from '../../types/risk';
import { Nullable } from '../../types/utils';
import { RiskMetaType } from './getRiskMeta';

export const getBuildingAndContentsRisk = ({
  riskMeta,
  businessDetails: { occupation },
  requestCovers,
  coverDetails,
  quote,
}: {
  riskMeta: RiskMetaType;
  businessDetails: Partial<BusinessDetails>;
  requestCovers: Cover[];
  coverDetails: Nullable<CoverDetails>;
  quote: Nullable<Quote>;
}) => ({
  ...riskMeta,
  riskClassCode: RiskClassCode.BuildingAndContents,
  riskDetail: {
    riskBPKFireBusinessInterruption: {
      occupationCode: occupation?.anzsicCode ?? '',
      occupationDescription: occupation?.occupation ?? '',
      business: occupation?.occupation ?? '',
      fire: {
        /** @note if EPS > 20 in MS we must pass construction = 4 to get the decline */
        construction:
          coverDetails.eps === EPS_OPTIONS[1].value
            ? Construction.EPSOver20
            : coverDetails.construction!,
        yearBuilt: coverDetails.yearBuilt!,
        sprinkler: coverDetails.sprinkler! ? 'Y' : 'N',
        ...(coverDetails.buildingSI && {
          buildingSI: coverDetails.buildingSI,
          buildingExcess: quote.levelOfExcess,
        }),
        ...(coverDetails.contentsSI && {
          contentsSI: coverDetails.contentsSI,
          contentsExcess: quote.levelOfExcess,
        }),
        flood: coverDetails.flood! ? 'Y' : 'N',
      },
      ...(requestCovers.includes(Cover.BusinessInterruption) && {
        businessInterruption: {
          indemnityPeriod: coverDetails.indemnityPeriod!,
          grossIncomeSI: coverDetails.grossIncome!,
          grossIncomeExcess: quote.levelOfExcess!,
        },
      }),
    },
  },
});
